import { render } from "./DiagramSidebar.vue?vue&type=template&id=081f059c&scoped=true"
import script from "./DiagramSidebar.vue?vue&type=script&lang=js"
export * from "./DiagramSidebar.vue?vue&type=script&lang=js"

import "./DiagramSidebar.vue?vue&type=style&index=0&id=081f059c&lang=css"
import "./DiagramSidebar.vue?vue&type=style&index=1&id=081f059c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081f059c"]])

export default __exports__